<script setup>
import { useI18n } from 'vue-i18n';
import BaseNode from './BaseNode.vue';

const props = defineProps({
  id: { type: String, required: true },
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();
</script>

<template>
  <BaseNode
    :node-id="props.id"
    :selected="selected"
    icon="i-lucide-flag"
    :type-label="t('SOPS.NODES.END')"
    :node-label="data.label"
    accent-class="bg-n-slate-9/15 text-n-slate-11"
    :has-source="false"
  />
</template>
